import React from "react"
import { useIntl } from "react-intl"
import PropTypes from "prop-types"
import { Box } from "@material-ui/core"
import Paper from "@material-ui/core/Paper"
import PageSubTitle from "../../component/header/PageSubTitle"
import DefaultParagraph from "./DefaultParagraph"
import useStyles from "./signingCeremonyStyle"

export default function SigningCeremonyTemplate(props) {
  const { messages, formName, children } = props
  const classes = useStyles()
  const { formatMessage: format } = useIntl()

  return (
    <Box pt={3}>
      <PageSubTitle subtitle={format(messages.title)} />
      <Paper className={classes.main}>
        {children !== undefined && children}
        {!children && (
          <DefaultParagraph
            messages={messages}
            formName={formName}
            format={format}
          />
        )}
      </Paper>
    </Box>
  )
}

SigningCeremonyTemplate.propTypes = {
  messages: PropTypes.shape({
    title: PropTypes.any.isRequired,
    mainInfo: PropTypes.any.isRequired,
    subInfo: PropTypes.any.isRequired,
    button: PropTypes.any.isRequired
  }).isRequired,
  formName: PropTypes.string.isRequired,
  children: PropTypes.any
}
SigningCeremonyTemplate.defaultProps = {
  children: undefined
}
